import { useRecoilState } from 'recoil';
import INotificationRepository from '../../2_domain/notification/iNotificationRepository';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';
import newNotificationAtom from '../notification/newNotificationAtom';

const useNewNotification = () => {
  const [newNotificaiton, setNewNotification] =
    useRecoilState(newNotificationAtom);
  const notificationRepo = Get.find<INotificationRepository>(
    'INotificationRepository'
  );

  const checkNewNotification = async () => {
    promiseResolver({
      promise: notificationRepo.getNewNotificationHistories(),
      successCallback: (bool) => {
        setNewNotification(bool);
      },
    });
  };
  return {
    newNotificaiton,
    checkNewNotification,
  };
};

export default useNewNotification;
